"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _reactHelmet = _interopRequireDefault(require("react-helmet"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var getComponentDisplayName = function getComponentDisplayName(Component) {
  return Component.displayName || Component.name || 'Unknown';
};
var _default = exports.default = function _default(propsOrFn) {
  return function (ComposedComponent) {
    var _WithHelmet;
    return (// eslint-disable-next-line react/prefer-stateless-function
      _WithHelmet = /*#__PURE__*/function (_React$Component) {
        (0, _inheritsLoose2.default)(WithHelmet, _React$Component);
        function WithHelmet() {
          return _React$Component.apply(this, arguments) || this;
        }
        var _proto = WithHelmet.prototype;
        _proto.render = function render() {
          var props = typeof propsOrFn === 'function' ? propsOrFn(this.props) : propsOrFn || {};
          var title = props.title,
            description = props.description,
            image = props.image,
            url = props.url,
            type = props.type,
            facebookId = props.facebookId,
            twitterId = props.twitterId,
            robots = props.robots,
            keywords = props.keywords,
            metaTitle = props.metaTitle;
          var helmetProps = {
            title: title,
            meta: [{
              name: 'description',
              property: 'og:description',
              content: description
            }, {
              property: 'fb:app_id',
              content: facebookId
            }, {
              property: 'og:url',
              content: url
            }, {
              property: 'og:image',
              content: image
            }, {
              property: 'og:type',
              content: type
            }, {
              name: 'twitter:card',
              content: 'summary'
            }, {
              name: 'twitter:site',
              content: twitterId
            }, {
              name: 'robots',
              property: 'robots',
              content: robots
            }, {
              name: 'keywords',
              content: keywords
            }, {
              name: 'title',
              content: metaTitle
            }].filter(function (_ref) {
              var content = _ref.content;
              return content;
            }),
            link: [{
              rel: 'canonical',
              href: url
            }].filter(function (_ref2) {
              var href = _ref2.href;
              return href;
            })
          };
          return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactHelmet.default, helmetProps), /*#__PURE__*/_react.default.createElement(ComposedComponent, this.props));
        };
        return WithHelmet;
      }(_react.default.Component), _WithHelmet.displayName = "WithHelmet(" + getComponentDisplayName(ComposedComponent) + ")", _WithHelmet
    );
  };
};